import alertCompletedIcon from '../../../assets/alert_complete.svg';
import { Stack, Typography, Box } from '@mui/material';
import theme from '../../../theme';
import { Circle } from '@mui/icons-material';

const bulletPoints = [
  '입력하신 이메일 주소로 이메일을 보냈습니다. 이메일의 링크를 클릭하여 비밀번호를 재설정해 주세요.',
  '이메일이 보이지 않는 경우, 휴지통, 스팸 메일함, 광고 메일함 등 메일이 있을 만한 다른 곳을 확인해 보세요.',
];

const SuccessfulSubmitEmail = () => {
  return (
    <Stack
      spacing={'30px'}
      sx={{ width: { lg: '49.1%', md: '83%', xs: '100%' } }}
      minWidth={{ xs: '320px' }}
    >
      <Stack spacing={2.5} alignItems={'center'} width={'100%'}>
        <img
          alt="alertCompletedIcon"
          src={alertCompletedIcon}
          sx={{ width: '32px', height: '32px' }}
        />
        <Typography fontSize={{ lg: '20px', md: '22px', xs: '20px' }} fontWeight={'bold'}>
          이메일이 전송되었습니다!
        </Typography>
      </Stack>

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            backgroundColor: theme.palette.grey.bg,
            borderRadius: 1,
            p: 4,
          }}
        >
          <Stack spacing={2.5}>
            {bulletPoints.map((point, index) => (
              <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <Circle
                  sx={{
                    fontSize: '2px',
                    color: theme.palette.black[4],
                    mt: '6px',
                  }}
                />
                <Typography
                  fontSize={'14px'}
                  color={theme.palette.black[4]}
                  sx={{
                    whiteSpace: 'pre-line',
                    lineHeight: 'normal',
                    display: 'block',
                  }}
                >
                  {point}
                </Typography>
              </Box>
            ))}
          </Stack>
        </Box>
      </Box>
    </Stack>
  );
};

export default SuccessfulSubmitEmail;
